/* eslint-env browser */
import * as React from 'react'

const PropTypes = require('prop-types')
const LargeGearItem = require('./LargeGearItem')
const DomHelper = require('../../../../client/clientjs/dom-helper.js')

class BestGearPage extends React.Component {
  constructor(props) {
    super(props)
    const { gears } = this.props
    this.state = {
      gears: gears || [],
    }
  }

  render() {
    const { gears } = this.state

    return (
      <div>
        <div className="has-margin-bottom-medium has-text-centered">
          {gears.map((elt, index, all) => (
            <span key={`category-anchor-link-${elt.category.id}`} className="is-size-7">
              {index > 0 && index < all.length && <span>&nbsp;&bull; </span>}
              <a
                href={`#best-gear-category-${elt.category.id}`}
                onClick={e => {
                  e.preventDefault()
                  DomHelper.scrollToTarget(document.scrollingElement, `#best-gear-category-${elt.category.id}`)
                }}
              >
                {elt.category.name}
              </a>
            </span>
          ))}
        </div>
        {gears.map(elt => (
          <div key={elt.category.id} id={`best-gear-category-${elt.category.id}`}>
            <article className="media">
              <figure className="media-left is-hidden-mobile">
                <p className="image is-32x32">
                  <img
                    src={((elt.category || {}).icon || {}).url_100}
                    alt={elt.category.name}
                    title={elt.category.name}
                  />
                </p>
              </figure>
              <div className="media-content">
                <div className="content">
                  <h2 className="is-size-6 has-text-weight-bold has-text-primary-blue">
                    <span className="icon is-hidden-tablet has-margin-right-small">
                      <img
                        src={((elt.category || {}).icon || {}).url_100}
                        alt={elt.category.name}
                        title={elt.category.name}
                      />
                    </span>
                    {elt.title || elt.category.name}
                  </h2>
                  <p>{elt.description}</p>
                </div>

                <div className="is-horizontal-scroll">
                  <div className="columns is-mobile is-multiline horizontal-scroll-container is-variable is-1">
                    {elt.gear.map(gear => (
                      <div key={gear.productArticleId} className="column is-6-mobile is-4-tablet">
                        <LargeGearItem key={gear.productArticleId} gear={gear} productCategory={elt.category} />
                      </div>
                    ))}
                  </div>
                  <div className="horizontal-scroll-nav hidden horizontal-scroll-nav-left">
                    <div className="horizontal-scroll-nav-container is-size-4 has-text-link">
                      <i className="fas faw fa-chevron-left" aria-hidden="true" />
                    </div>
                  </div>
                  <div className="horizontal-scroll-nav hidden horizontal-scroll-nav-right">
                    <div className="horizontal-scroll-nav-container is-size-4 has-text-link">
                      <i className="fas faw fa-chevron-right" aria-hidden="true" />
                    </div>
                  </div>
                </div>
              </div>
            </article>
          </div>
        ))}
      </div>
    )
  }
}

BestGearPage.propTypes = {
  gears: PropTypes.array.isRequired,
}

module.exports = BestGearPage
